import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SideMenu from "./SideMenu";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

function SideMenuTabs({ isSidebarOpen }) {
  const [selectedMenu, setSelectedMenu] = useState(0);
  const [role, setRole] = useState("");
  const [sessionUser, setSessionUser] = useState(null);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const location = useLocation();
  const sideMenu = SideMenu(role, sessionUser);

  useEffect(() => {
    const tabIndex = sessionStorage.getItem("tab-index");
    if (tabIndex !== null) {
      setSelectedMenu(JSON.parse(tabIndex));
    }
    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setSessionUser(session.user);
    }
  }, []);

  useEffect(() => {
    sideMenu.forEach((menu, index) => {
      if (menu.children) {
        const childIndex = menu.children.findIndex(
          (child) => child.url === location.pathname
        );
        if (childIndex !== -1) {
          setExpandedMenu(index);
          setSelectedMenu(index);
        }
      } else if (menu.url === location.pathname) {
        setSelectedMenu(index);
      }
    });
  }, [location.pathname, role]);

  const handleTabChange = (index, hasChildren) => {
    if (hasChildren) {
      setExpandedMenu(expandedMenu === index ? null : index);
    } else {
      setSelectedMenu(index);
      sessionStorage.setItem("tab-index", JSON.stringify(index));
    }
  };

  const itemClass = (active) =>
    `flex items-center min-h-11 px-3 gap-3 cursor-pointer transition-colors duration-200 ${
      active
        ? "text-white bg-white/10 border-r-2 border-gx-red"
        : "text-white/80 hover:text-white hover:bg-white/5"
    }`;

  return (
    <nav className="custom-scrollbar text-white print:hidden">
      {sideMenu.map((menu, index) => (
        <div key={index}>
          {!menu.ignore && (
            <>
              {menu.children ? (
                <div>
                  <Tooltip
                    title={!isSidebarOpen ? menu.title : ""}
                    arrow
                    placement="right"
                  >
                    <button
                      type="button"
                      className={`${itemClass(selectedMenu === index)} w-full text-left`}
                      onClick={() => handleTabChange(index, true)}
                    >
                      <span className="w-5 shrink-0 flex justify-center">
                        {menu.icon}
                      </span>
                      {isSidebarOpen && (
                        <>
                          <span className="font-medium flex-1 text-sm">
                            {menu.title}
                          </span>
                          <FontAwesomeIcon
                            icon={
                              expandedMenu === index ? faChevronUp : faChevronDown
                            }
                            className="text-xs"
                          />
                        </>
                      )}
                    </button>
                  </Tooltip>
                  {isSidebarOpen && expandedMenu === index && (
                    <div className="bg-black/20 flex flex-col">
                      {menu.children.map((child, childIdx) => (
                        <Link key={childIdx} to={child.url}>
                          <div
                            className={`flex items-center min-h-11 px-3 pl-10 gap-3 text-sm ${
                              location.pathname === child.url
                                ? "text-white font-semibold bg-white/10"
                                : "text-white/70 hover:text-white hover:bg-white/5"
                            }`}
                            onClick={() => setSelectedMenu(index)}
                          >
                            <span>{child.icon}</span>
                            <span>{child.title}</span>
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link to={menu.url}>
                  <Tooltip
                    title={!isSidebarOpen ? menu.title : ""}
                    arrow
                    placement="right"
                  >
                    <div
                      className={itemClass(selectedMenu === index)}
                      onClick={() => handleTabChange(index, false)}
                    >
                      <span className="w-5 shrink-0 flex justify-center">
                        {menu.icon}
                      </span>
                      <span
                        className={`font-medium text-sm whitespace-nowrap ${
                          isSidebarOpen ? "opacity-100" : "opacity-0 w-0 overflow-hidden"
                        }`}
                      >
                        {menu.title}
                      </span>
                    </div>
                  </Tooltip>
                </Link>
              )}
            </>
          )}
        </div>
      ))}
    </nav>
  );
}

export default SideMenuTabs;
